import type { ReactNode } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Container, Stack, Typography } from '@mui/material';

export function PublicSignerStateCard({
  description,
  icon,
  severity,
  title
}: {
  description: string;
  icon?: ReactNode;
  severity: 'error' | 'info' | 'success';
  title: string;
}) {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 8, md: 14 } }}>
      <Stack
        spacing={3}
        sx={(theme) => ({
          backgroundColor: 'background.paper',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '20px',
          p: { xs: 3, sm: 4 }
        })}
      >
        <Stack alignItems="center" spacing={1.5}>
          <Box color={severity === 'success' ? 'success.main' : 'primary.main'}>
            {icon ?? <DescriptionOutlinedIcon fontSize="large" />}
          </Box>
          <Typography
            align="center"
            color="secondary.main"
            fontWeight={600}
            variant="h6"
          >
            {title}
          </Typography>
          <Typography
            align="center"
            color="#364955"
            sx={{ maxWidth: 420 }}
            variant="body2"
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
}
